import React, { useState } from 'react';
import "./App.css";
import 'antd/dist/reset.css';
import Home from './components/home';
import ReferralCX from './components/referralCX';
import ReferralSolarSquare from './components/referralSolarSquare';
import ReferralStatus from './components/referralStatus';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import PageNotFound from './components/pageNotFound/404Page';
import ReferNow from './components/referNow';
import RedirectToPlayStore from './components/redirectToPlayStore';
import ReferralCXLogin from './components/referralCX/login';
import ReferralCXLead from './components/referralCX/lead';
import ReferralStatusLogin from "./components/referralStatus/login";
import ReferralStatusOTP from "./components/referralStatus/verifyOTP";
import ReferalStatusList from "./components/referralStatus/referralList";
import ReferalStatusDetails from "./components/referralStatus/referral";
import { useNavigate } from "react-router-dom";
import ForgotPassword from './components/auth/forgotPassword';
import ResetCredentials from './components/auth/resetCredentials';

function App() {
	const navigate = useNavigate();
	{/* Referral CX states  */ }
	const [step, setStep] = useState(1);
	const [token, setToken] = useState("");
	const [isLoginThrouPersonalizedLink, setIsLoginThrouPersonalizedLink] = useState(false);
	function onNext(data) {
		navigate("/referral/cx");
		setToken(data);
		setStep(2);
	};
	function onPrev() {
		setToken("");
		setStep(1);
	};

	{/* Referral status states  */ }
	const [stepReferralStatus, setStepReferralStatus] = useState(1);
	const [mobile, setMobile] = useState("");
	const [sessionIdReferralStatus, setSessionIdReferralStatus] = useState("");
	const [tokenReferralStatus, setTokenReferralStatus] = useState("");
	const [bankAccountReferralStatus, setBankAccountReferralStatus] = useState({});
	const [referralId, setReferralId] = useState("");
	const [selectedTab, setSelectedTab] = useState("1");
	const [search, setSearch] = useState("");
	const [referrals, setReferrals] = useState({
		PENDING: [],
		IN_PROGRESS: [],
		COMPLETED: [],
	});
	const [bankAccountModal, setBankAccountModal] = useState(false);

	return (
		<Routes>
			<Route path="/" element={<Home />} />
			{/* Referral CX Routes */}	
			<Route path="/referral/cx" element={<ReferralCX step={step} setStep={setStep} token={token} setToken={setToken} />} />
			<Route path="/referral/cx/login/:id?" element={<ReferralCXLogin onNext={onNext} setStep={setStep} setToken={setToken} setIsLoginThrouPersonalizedLink={setIsLoginThrouPersonalizedLink} />} />
			<Route path="/referral/cx/refer-now" element={<ReferralCXLead token={token} setStep={setStep} onPrev={onPrev} isLoginThrouPersonalizedLink={isLoginThrouPersonalizedLink} />} />
			{/* Referral Solar-Square Routes */}
			<Route path="/referral/solar-square" element={<ReferralSolarSquare />} />
			{/* Referral Status Routes */}
			<Route path="/referral/status" element={<ReferralStatus step={stepReferralStatus} setStep={setStepReferralStatus} mobile={mobile} setMobile={setMobile} sessionId={sessionIdReferralStatus} setSessionId={setSessionIdReferralStatus} token={tokenReferralStatus} setToken={setTokenReferralStatus} bankAccount={bankAccountReferralStatus} setBankAccount={setBankAccountReferralStatus} referralId={referralId} />} />
			<Route path="/referral/status/login" element={<ReferralStatusLogin setStepReferralStatus={setStepReferralStatus} mobile={mobile} setMobile={setMobile}
				onNext={(data) => {
					navigate("/referral/status/verify-otp")
					setSessionIdReferralStatus(data);
					setStepReferralStatus(2);
				}}
			/>} />
			<Route path="/referral/status/verify-otp" element={<ReferralStatusOTP
				mobile={mobile}
				sessionId={sessionIdReferralStatus}
				setSessionId={setSessionIdReferralStatus}
				onPrev={() => {
					navigate("/referral/status/login");
					setStepReferralStatus(stepReferralStatus - 1);
					setSessionIdReferralStatus("");
				}}
				onNext={(data) => {
					navigate("/referral/status/referral-list");
					setTokenReferralStatus(data?.token);
					setBankAccountReferralStatus(data?.bankAccount);
					setStepReferralStatus(3);
				}}
			/>} />
			<Route path="/referral/status/referral-list" element={<ReferalStatusList
				token={tokenReferralStatus}
				referrals={referrals}
				setReferrals={setReferrals}
				setStepReferralStatus={setStepReferralStatus}
				onPrev={() => {
					navigate("/referral/status/login");
					setStepReferralStatus(stepReferralStatus - 2)
				}}
				onNext={(data) => {
					if (data) {
						navigate('/referral/status/referral-detail')
						setReferralId(data);
						setStepReferralStatus(stepReferralStatus + 1);
					} else {
						navigate("/referral/cx");
					}
				}}
				selectedTab={selectedTab}
				setSelectedTab={setSelectedTab}
				search={search}
				setSearch={setSearch}
			/>} />
			<Route path="/referral/status/referral-detail" element={<ReferalStatusDetails
				token={tokenReferralStatus}
				referralId={referralId}
				onPrev={() => {
					navigate('/referral/status/referral-list');
					setStepReferralStatus(stepReferralStatus-1);
				}}
				bankAccountModal={bankAccountModal}
				setBankAccountModal={setBankAccountModal}
				stepReferralStatus={stepReferralStatus}
				bankAccount={bankAccountReferralStatus}
				setBankAccount={setBankAccountReferralStatus}
			/>} />
			<Route path="/referral/csat/:id" element={<ReferNow />} />
			<Route path="/referral/refer-now" element={<RedirectToPlayStore />} />
			<Route path="/forgot-password/:token" element={<ForgotPassword />} />
			<Route path="/reset-credentials" element={<ResetCredentials />} />

			<Route path="*" element={<PageNotFound />} />
		</Routes>
	);
}

export default App;
